import { useMemo } from 'preact/hooks';

import type { TemplateContextMap, TemplateFunction, TemplateResult } from 'Components/types';
import { dialogClosed, dialogOpened, type OpenDialogMetadata } from 'Core/actions/dialog';
import { createDialogOpenedSelector } from 'Core/selectors/dialog';
import { useDispatch, useSelector } from 'Core/store';
import { cloneSafe } from 'Utils/components';

interface Props {
  template: TemplateFunction<DialogButtonTemplateParams>;
  dialogName: string;
  metadata?: OpenDialogMetadata;
  templateParams?: TemplateContextMap;
}

export type DialogButtonTemplateParams = TemplateContextMap & {
  isDialogOpened: boolean;
};

export default function DialogButton({
  template,
  dialogName,
  metadata = {},
  templateParams = {},
}: Props): TemplateResult {
  const dispatch = useDispatch();
  const opened = useSelector(useMemo(() => createDialogOpenedSelector(dialogName), [dialogName]));

  const onClick = () => {
    if (!opened) {
      dispatch(dialogOpened(dialogName, metadata));
    } else {
      dispatch(dialogClosed(dialogName));
    }
  };

  const component = template.call({ ...templateParams, isDialogOpened: opened });
  return cloneSafe(component, null, { onClick });
}
